import { ListItemText } from "@mui/material";
import moment from 'moment';
import { StyledEstablecimientos } from "../../styled/Prevencion";

const DatosDelEstablecimientoCard = ({ data }) => {
  return (
    <>
      <StyledEstablecimientos.List>
        <StyledEstablecimientos.ListItem key="nombre">
          <StyledEstablecimientos.Label>
            Nombre Establecimiento
          </StyledEstablecimientos.Label>
          <ListItemText
            secondary={
              data?.nombre ? data.nombre.split("-")[0] : "Sin Información"
            }
          />
        </StyledEstablecimientos.ListItem>
        <StyledEstablecimientos.ListItem key="domicilio">
          <StyledEstablecimientos.Label>Domicilio</StyledEstablecimientos.Label>
          <ListItemText
            secondary={data?.domicilio ? data?.domicilio : "Sin Información"}
          />
        </StyledEstablecimientos.ListItem>
        <StyledEstablecimientos.ListItem key="matrizUnica">
          <StyledEstablecimientos.Label>Matriz Única</StyledEstablecimientos.Label>
          <ListItemText
            secondary={data?.matrizUnica ? data.matrizUnica : "Sin Información"}
          />
        </StyledEstablecimientos.ListItem>
        <StyledEstablecimientos.ListItem key="codigoIntercambio">
          <StyledEstablecimientos.Label>Cód. Intercambio</StyledEstablecimientos.Label>
          <ListItemText
            secondary={
              data?.codigoIntercambio
                ? data?.codigoIntercambio
                : "Sin Información"
            }
          />
        </StyledEstablecimientos.ListItem>
        <StyledEstablecimientos.ListItem key="actividad">
          <StyledEstablecimientos.Label>
            Actividad Establecimiento
          </StyledEstablecimientos.Label>
          <ListItemText
            secondary={data?.actividad ? data.actividad : "Sin Información"}
          />
        </StyledEstablecimientos.ListItem>

        <StyledEstablecimientos.ListItem key="fechaInicioActividad">
          <StyledEstablecimientos.Label>
            Fecha de Inicio Actividad
          </StyledEstablecimientos.Label>
          <ListItemText
            secondary={data?.fechaInicioActividad ? moment(data.fechaInicioActividad).format("DD/MM/YYYY") : "Sin Información"}
          />
        </StyledEstablecimientos.ListItem>

        <StyledEstablecimientos.ListItem>
          <StyledEstablecimientos.Label>Fecha de Presentación</StyledEstablecimientos.Label>
          <ListItemText
            secondary={moment(new Date()).format("DD/MM/YYYY")}
          />
        </StyledEstablecimientos.ListItem>
        <StyledEstablecimientos.ListItem>
          <StyledEstablecimientos.Label>Motivo de Presentación</StyledEstablecimientos.Label>
          <ListItemText
            secondary={"Presentación Anual"}
          />
        </StyledEstablecimientos.ListItem>
        <StyledEstablecimientos.ListItem>
          <StyledEstablecimientos.Label>Actividad Principal de la Empresa</StyledEstablecimientos.Label>
          <ListItemText
            secondary={data?.actividadEmpleador ?? "Sin Información"}
          />
        </StyledEstablecimientos.ListItem>
      </StyledEstablecimientos.List >
    </>
  );
};

export default DatosDelEstablecimientoCard;
